import { defineStore } from 'pinia'
import groupApi from '@/api/group'
import groupUserApi from '@/api/groupuser'
import type { GroupAttributes, CreateGroupAttributes, UpdateGroupAttributes } from 'common'

const useGroupStore = defineStore('group', {
  state: () => ({
    groups: [] as GroupAttributes[],
    groupsLoading: false
  }),
  actions: {
    async index(organizationId: number) {
      this.groupsLoading = true

      const groups = await groupApi.index(organizationId)
      this.groups = groups

      this.groupsLoading = false

      return groups
    },
    async show(groupId: number) {
      const groups = await groupApi.show(groupId)
      return groups
    },
    async create(organizationId: number, data: CreateGroupAttributes) {
      const group = await groupApi.create(organizationId, data)
      this.groups.push(group)

      return group
    },
    async createDefault(organizationId: number) {
      const group = await groupApi.createDefault(organizationId)
      this.groups.push(group)

      return group
    },
    async setDefault(groupId: number) {
      return groupApi.setDefault(groupId)
    },
    async setExternal(groupId: number) {
      return groupApi.setExternal(groupId)
    },
    async update(id: number, data: UpdateGroupAttributes) {
      const group = await groupApi.update(id, data)
      const idx = this.groups.findIndex((g: GroupAttributes) => g.id === group.id)
      this.groups = [...this.groups.slice(0, idx), group, ...this.groups.slice(idx + 1)]

      return group
    },
    async delete(id: number) {
      const ok = await groupApi.delete(id)
      if (!ok) {
        return false
      }

      const idx = this.groups.findIndex((g: GroupAttributes) => g.id === id)
      this.groups = [...this.groups.slice(0, idx), ...this.groups.slice(idx + 1)]
      return true
    },
    async addUsersToGroup(id: number, userIds: string[]) {
      return groupUserApi.create(id, userIds)
    },
    async removeUserFromGroup(id: number, userId: string) {
      return groupUserApi.delete(id, userId)
    }
  }
})

export default useGroupStore
